import {
  useGetSurveyByIdLazyQuery,
} from "graphql/__generated__/hooks";
import { useAppSelector } from "hooks/useAppSelector";
import { useAuthUser } from "hooks/useAuthUser";
import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { organizationSelectedSelector } from "reduxStore/organization/selectors";
import { Survey } from "types/survey";
import { ROLES } from "types/user";

export const useSurveyDetail = () => {
  const { surveyId, organizationId } = useParams();
  const [getSurveyById, { data, loading }] = useGetSurveyByIdLazyQuery();

  const organization = useAppSelector(organizationSelectedSelector);
  const { role } = useAuthUser();
  const isOrgView = !!organizationId;

  const survey = useMemo<Survey | null>(() => {
    if (!data?.survey_by_pk) return null;
    return {
      survey_id: data.survey_by_pk.survey_id,
      name: data.survey_by_pk.name || "",
      org_id: data.survey_by_pk.org_id || undefined,
      questions: data.survey_by_pk.questions?.map((sq: any) => ({
        survey_question_id: sq.survey_question_id,
        question: {
          question_id: sq.question?.question_id,
          title: sq.question?.title || "",
          type: sq.question?.type || "open_ended",
          body: sq.question?.body || "",
          order: sq.question?.order || 0,
          options: sq.question?.options?.map((opt: any) => ({
            option_id: opt.option_id,
            text: opt.text || "",
            order: opt.order || 0,
            question_id: sq.question?.question_id || "",
          })) || [],
        },
      })) || [],
    };
  }, [data]);

  useEffect(() => {
    if (surveyId) {
      getSurveyById({ variables: { surveyId } });
    }
  }, [surveyId, getSurveyById]);

  return {
    survey,
    loading,
    role,
    isOrgView,
    organizationId,
  };
};
